import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const insuranceRatingsAdapter = getAdapter({ idFieldName: 'value' });

const insuranceRatingsSlice = createSlice({
  name: 'insuranceRatings',
  initialState: insuranceRatingsAdapter.getInitialState(),
  reducers: {
    setInsuranceRatings: (state, { payload: { insuranceRatings } }) => {
      insuranceRatingsAdapter.setAll(state, insuranceRatings);
    },
  },
});

const selectors = insuranceRatingsAdapter.getSelectors(({ insuranceRatings }) => insuranceRatings);

export const getInsuranceRatings = (state) => selectors.selectAll(state);

export const {
  setInsuranceRatings,
} = insuranceRatingsSlice.actions;

export default insuranceRatingsSlice.reducer;
